
// import React, { useEffect, useState, useMemo, useCallback } from "react";
// import axios from "axios";
// import { useAuth } from "../context/AuthContext";
// import { API as BASE_API } from "../components/config";
// import "../style/ModuloNotasFinales.css";

// const API_ROOT = `${BASE_API}/notas-finales`;

// const ModuloNotasFinales = () => {
//   const { token, user } = useAuth();

//   const [asignaciones, setAsignaciones] = useState([]);
//   const [periodos, setPeriodos] = useState([]);

//   const [grados, setGrados] = useState([]);
//   const [grupos, setGrupos] = useState([]);
//   const [materias, setMaterias] = useState([]);

//   const [seleccion, setSeleccion] = useState({
//     grado: "",
//     grupo: "",
//     materia: "",
//     periodo: "",
//     asignacionId: null,
//   });

//   const [notas, setNotas] = useState([]);
//   const [editando, setEditando] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [puedePublicar, setPuedePublicar] = useState(true);
//   const [mensajeFecha, setMensajeFecha] = useState("");

//   /* =========================
//       AXIOS CONFIG
//   ========================= */
//   const api = useMemo(() => {
//     const instance = axios.create({
//       baseURL: API_ROOT,
//       withCredentials: true,
//     });

//     instance.interceptors.request.use((config) => {
//       if (token) config.headers.Authorization = `Bearer ${token}`;
//       config.headers["X-Tenant-ID"] = user?.tenant_id || "";
//       config.headers["X-Sede-ID"] = user?.sede_id || "";
//       return config;
//     });

//     return instance;
//   }, [token, user]);

//   /* =========================
//       DATA INICIAL
//   ========================= */
//   const fetchDataInicial = useCallback(async () => {
//     try {
//       const [resAsig, resPer] = await Promise.all([
//         api.get("/asignaciones-profesor"),
//         api.get("/periodos"),
//       ]);

//       const dataAsig = Array.isArray(resAsig.data) ? resAsig.data : [];
//       const dataPer = Array.isArray(resPer.data) ? resPer.data : [];

//       setAsignaciones(dataAsig);
//       setPeriodos(dataPer);
//       setGrados([...new Set(dataAsig.map((a) => a.grado))]);
//     } catch (err) {
//       console.error("❌ Error inicial:", err.response?.data || err.message);
//     }
//   }, [api]);

//   useEffect(() => {
//     if (token) fetchDataInicial();
//   }, [token, fetchDataInicial]);

//   /* =========================
//       FILTROS MANAGE
//   ========================= */
//   const handleGradoChange = (v) => {
//     const gruposFiltrados = asignaciones
//       .filter((a) => String(a.grado) === String(v))
//       .map((a) => a.grupo);

//     setGrupos([...new Set(gruposFiltrados)]);
//     setMaterias([]);
//     setNotas([]);
//     setSeleccion({ grado: v, grupo: "", materia: "", periodo: "", asignacionId: null });
//   };

//   const handleGrupoChange = (v) => {
//     const materiasFiltradas = asignaciones
//       .filter((a) => String(a.grado) === String(seleccion.grado) && String(a.grupo) === String(v))
//       .map((a) => ({ id: a.materia_id, nombre: a.materia, asignacion_id: a.id }));

//     const unique = [...new Map(materiasFiltradas.map((m) => [m.id, m])).values()];
//     setMaterias(unique);
//     setNotas([]);
//     setSeleccion((prev) => ({ ...prev, grupo: v, materia: "", periodo: "", asignacionId: null }));
//   };

//   const handleMateriaChange = (v) => {
//     const mat = materias.find((m) => String(m.id) === String(v));
//     setSeleccion((prev) => ({ ...prev, materia: v, asignacionId: mat?.asignacion_id || null }));
//   };

//   const handlePeriodoChange = (v) => {
//     const per = periodos.find((p) => String(p.id) === String(v));
//     setSeleccion((prev) => ({ ...prev, periodo: v }));

//     if (per?.fecha_limite_subida_notas) {
//       const vencido = new Date() > new Date(per.fecha_limite_subida_notas);
//       setPuedePublicar(!vencido);
//       setMensajeFecha(vencido ? `❌ Fecha límite vencida (${per.fecha_limite_subida_notas})` : "");
//     } else {
//       setPuedePublicar(true);
//       setMensajeFecha("");
//     }
//   };

//   /* =========================
//       CARGAR NOTAS
//   ========================= */
// const cargarNotas = useCallback(async () => {
//   const { grado, grupo, materia, periodo } = seleccion;
//   if (!grado || !grupo || !materia || !periodo) {
//     setNotas([]);
//     return;
//   }
//   setLoading(true);
//   try {
//     const res = await api.get("/notas-finales", {
//       params: { grado, grupo, materia_id: materia, periodo_id: periodo },
//     });

//     // 🔥 Cambiamos toFixed(2) por Number() para limpiar ceros innecesarios
//     const dataFormateada = (res.data || []).map(n => ({
//       ...n,
//       nota_final: n.nota_final !== null ? Number(n.nota_final).toString() : ""
//     }));
    
//     setNotas(dataFormateada);
//   } catch (err) {
//     console.error("❌ Error notas:", err.response?.data || err.message);
//     setNotas([]);
//   } finally {
//     setLoading(false);
//   }
// }, [api, seleccion]);

//   useEffect(() => {
//     cargarNotas();
//   }, [cargarNotas]);

//   /* =========================
//       INPUTS & FORMATTING (🔥)
//   ========================= */
//   const handleNotaUpdate = (index, campo, valor) => {
//   setNotas((prev) => {
//     const copia = [...prev];
//     if (campo === "nota_final") {
//       let limpio = valor.replace(",", ".");
//       if (limpio === "" || limpio === "." || !isNaN(limpio)) {
//         copia[index][campo] = limpio;
//       }
//     } else {
//       copia[index][campo] = valor;
//     }
//     return copia;
//   });
// };
// const handleBlurNota = (index) => {
//   setNotas((prev) => {
//     const copia = [...prev];
//     const val = copia[index].nota_final;
//     if (val !== "" && !isNaN(val)) {
//       // Convierte "70.00" en "70" automáticamente
//       copia[index].nota_final = Number(val).toString();
//     }
//     return copia;
//   });
// };

//   /* =========================
//       ACCIONES (GUARDAR/PUBLICAR)
//   ========================= */
//   const guardarNotas = async () => {
//     try {
//       const payload = notas.map((n) => ({
//         estudiante_id: n.estudiante_id,
//         nota_final: n.nota_final === "" ? 0 : parseFloat(n.nota_final).toFixed(2),
//         comentario: n.comentario || "",
//         materia_id: seleccion.materia,
//         periodo_id: seleccion.periodo,
//         grado: seleccion.grado,
//         grupo: seleccion.grupo,
//       }));

//       await api.post("/guardar-notas", { notas: payload });
//       alert("✅ Notas guardadas correctamente");
//       setEditando(false);
//       cargarNotas();
//     } catch (err) {
//       alert(err.response?.data?.msg || "Error guardando notas");
//     }
//   };

//   const publicarNotas = async () => {
//     if (!puedePublicar) return alert("❌ Fecha límite vencida");
//     try {
//       await api.post("/notas/publicar", {
//         grado: seleccion.grado,
//         grupo: seleccion.grupo,
//         materia_id: seleccion.materia,
//         periodo_id: seleccion.periodo,
//       });
//       alert("📢 Notas publicadas");
//       cargarNotas();
//     } catch (err) {
//       alert(err.response?.data?.msg || "Error publicando");
//     }
//   };

//   /* =========================
//       VISTA (UI)
//   ========================= */
//   return (
//     <div className="modulo-notas-container">
//       <h2>📘 Calificaciones Finales</h2>

//       <div className="filtros-grid">
//         <select value={seleccion.grado} onChange={(e) => handleGradoChange(e.target.value)}>
//           <option value="">Grado</option>
//           {grados.map((g) => <option key={g} value={g}>{g}</option>)}
//         </select>

//         <select value={seleccion.grupo} onChange={(e) => handleGrupoChange(e.target.value)}>
//           <option value="">Grupo</option>
//           {grupos.map((g) => <option key={g} value={g}>{g}</option>)}
//         </select>

//         <select value={seleccion.materia} onChange={(e) => handleMateriaChange(e.target.value)}>
//           <option value="">Materia</option>
//           {materias.map((m) => <option key={m.id} value={m.id}>{m.nombre}</option>)}
//         </select>

//         <select value={seleccion.periodo} onChange={(e) => handlePeriodoChange(e.target.value)}>
//           <option value="">Periodo</option>
//           {periodos.map((p) => <option key={p.id} value={p.id}>{p.nombre}</option>)}
//         </select>
//       </div>

//       {mensajeFecha && <p className="mensaje-fecha-alerta">{mensajeFecha}</p>}

//       {loading ? (
//         <div className="loader">Cargando estudiantes...</div>
//       ) : (
//         <table className="tabla-notas-finales">
//           <thead>
//             <tr>
//               <th>Estudiante</th>
//               <th style={{ width: "120px" }}>Nota</th>
//               <th>Desempeño</th>
//               <th>Comentario</th>
//             </tr>
//           </thead>
//           <tbody>
//             {notas.length === 0 ? (
//               <tr><td colSpan="4" className="text-center">Seleccione los filtros para cargar la planilla</td></tr>
//             ) : (
//               notas.map((n, i) => (
//                 <tr key={n.estudiante_id}>
//                   <td className="nombre-estudiante">
//                     {n.apellidos_estudiante} {n.nombres_estudiante}
//                   </td>
//                   <td>
//                     <input
//                       type="text"
//                       className="input-nota-final"
//                       disabled={!editando}
//                       value={n.nota_final}
//                       onChange={(e) => handleNotaUpdate(i, "nota_final", e.target.value)}
//                       onBlur={() => handleBlurNota(i)}
//                       placeholder="0.00"
//                     />
//                   </td>
//                   <td className="col-desempeno">{n.desempeño || "-"}</td>
//                   <td>
//                     <input
//                       className="input-comentario"
//                       disabled={!editando}
//                       value={n.comentario || ""}
//                       onChange={(e) => handleNotaUpdate(i, "comentario", e.target.value)}
//                       placeholder="Sin comentario"
//                     />
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       )}

//       <div className="acciones-footer">
//         {!editando ? (
//           <button className="btn-editar" onClick={() => setEditando(true)}>✏️ Editar Notas</button>
//         ) : (
//           <button className="btn-guardar" onClick={guardarNotas}>💾 Guardar Cambios</button>
//         )}
//         <button 
//           className="btn-publicar" 
//           onClick={publicarNotas}
//           disabled={!puedePublicar || notas.length === 0}
//         >
//           📢 Publicar al Boletín
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ModuloNotasFinales;



import React, { useEffect, useState, useMemo, useCallback } from "react";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { API as BASE_API } from "../components/config";
import "../style/ModuloNotasFinales.css";

const API_ROOT = `${BASE_API}/notas-finales`;

const ModuloNotasFinales = () => {
  const { token, user } = useAuth();

  const [asignaciones, setAsignaciones] = useState([]);
  const [periodos, setPeriodos] = useState([]);

  const [grados, setGrados] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [materias, setMaterias] = useState([]);

  const [seleccion, setSeleccion] = useState({
    grado: "",
    grupo: "",
    materia: "",
    periodo: "",
    asignacionId: null,
  });

  const [notas, setNotas] = useState([]);
  const [editando, setEditando] = useState(false);
  const [loading, setLoading] = useState(false);
  const [puedePublicar, setPuedePublicar] = useState(true);
  const [mensajeFecha, setMensajeFecha] = useState("");

  /* =========================
      AXIOS CONFIG
  ========================= */
  const api = useMemo(() => {
    const instance = axios.create({
      baseURL: API_ROOT,
      withCredentials: true,
    });

    instance.interceptors.request.use((config) => {
      if (token) config.headers.Authorization = `Bearer ${token}`;
      config.headers["X-Tenant-ID"] = user?.tenant_id || "";
      config.headers["X-Sede-ID"] = user?.sede_id || "";
      return config;
    });

    return instance;
  }, [token, user]);

  /* =========================
      DATA INICIAL
  ========================= */
  const fetchDataInicial = useCallback(async () => {
    try {
      const [resAsig, resPer] = await Promise.all([
        api.get("/asignaciones-profesor"),
        api.get("/periodos"),
      ]);

      const dataAsig = Array.isArray(resAsig.data)
        ? resAsig.data
        : Array.isArray(resAsig.data?.asignaciones)
          ? resAsig.data.asignaciones
          : [];

      // 🔧 CORREGIDO: el backend devuelve un objeto { periodos: [...], periodo_activo_id, ... }
      // no un array directo
      const dataPer = Array.isArray(resPer.data?.periodos)
        ? resPer.data.periodos
        : Array.isArray(resPer.data)
          ? resPer.data
          : [];

      const periodoActivoId = resPer.data?.periodo_activo_id || null;

      setAsignaciones(dataAsig);
      setPeriodos(dataPer);
      setGrados([...new Set(dataAsig.map((a) => a.grado))]);

      // 🔧 NUEVO: preseleccionar el periodo activo automáticamente
      if (periodoActivoId) {

        setSeleccion((prev) => ({
          ...prev,
          periodo: String(periodoActivoId)
        }));

        const per = dataPer.find(
          (p) => String(p.id) === String(periodoActivoId)
        );

        if (per?.fecha_limite_subida_notas) {
          const vencido = new Date() > new Date(per.fecha_limite_subida_notas);
          setPuedePublicar(!vencido);
          setMensajeFecha(
            vencido
              ? `❌ Fecha límite vencida (${per.fecha_limite_subida_notas})`
              : ""
          );
        }
      }

    } catch (err) {
      console.error("❌ Error inicial:", err.response?.data || err.message);
    }
  }, [api]);

  useEffect(() => {
    if (token) fetchDataInicial();
  }, [token, fetchDataInicial]);

  /* =========================
      FILTROS MANAGE
  ========================= */
  const handleGradoChange = (v) => {
    const gruposFiltrados = asignaciones
      .filter((a) => String(a.grado) === String(v))
      .map((a) => a.grupo);

    setGrupos([...new Set(gruposFiltrados)]);
    setMaterias([]);
    setNotas([]);

    // 🔧 Mantiene el periodo ya seleccionado (activo) al cambiar de grado
    setSeleccion((prev) => ({
      ...prev,
      grado: v,
      grupo: "",
      materia: "",
      asignacionId: null
    }));
  };

  const handleGrupoChange = (v) => {
    const materiasFiltradas = asignaciones
      .filter((a) => String(a.grado) === String(seleccion.grado) && String(a.grupo) === String(v))
      .map((a) => ({ id: a.materia_id, nombre: a.materia, asignacion_id: a.id }));

    const unique = [...new Map(materiasFiltradas.map((m) => [m.id, m])).values()];
    setMaterias(unique);
    setNotas([]);

    // 🔧 Mantiene el periodo ya seleccionado (activo) al cambiar de grupo
    setSeleccion((prev) => ({
      ...prev,
      grupo: v,
      materia: "",
      asignacionId: null
    }));
  };

  const handleMateriaChange = (v) => {
    const mat = materias.find((m) => String(m.id) === String(v));
    setSeleccion((prev) => ({ ...prev, materia: v, asignacionId: mat?.asignacion_id || null }));
  };

  const handlePeriodoChange = (v) => {
    const per = periodos.find((p) => String(p.id) === String(v));
    setSeleccion((prev) => ({ ...prev, periodo: v }));

    if (per?.fecha_limite_subida_notas) {
      const vencido = new Date() > new Date(per.fecha_limite_subida_notas);
      setPuedePublicar(!vencido);
      setMensajeFecha(vencido ? `❌ Fecha límite vencida (${per.fecha_limite_subida_notas})` : "");
    } else {
      setPuedePublicar(true);
      setMensajeFecha("");
    }
  };

  /* =========================
      CARGAR NOTAS
  ========================= */
  const cargarNotas = useCallback(async () => {
    const { grado, grupo, materia, periodo } = seleccion;
    if (!grado || !grupo || !materia || !periodo) {
      setNotas([]);
      return;
    }
    setLoading(true);
    try {
      const res = await api.get("/notas-finales", {
        params: { grado, grupo, materia_id: materia, periodo_id: periodo },
      });

      const listaNotas = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data?.estudiantes)
          ? res.data.estudiantes
          : [];

      const dataFormateada = listaNotas.map(n => ({
        ...n,
        nota_final: n.nota_final !== null && n.nota_final !== undefined
          ? Number(n.nota_final).toString()
          : ""
      }));

      setNotas(dataFormateada);
    } catch (err) {
      console.error("❌ Error notas:", err.response?.data || err.message);
      setNotas([]);
    } finally {
      setLoading(false);
    }
  }, [api, seleccion]);

  useEffect(() => {
    cargarNotas();
  }, [cargarNotas]);

  /* =========================
      INPUTS & FORMATTING
  ========================= */
  const handleNotaUpdate = (index, campo, valor) => {
    setNotas((prev) => {
      const copia = [...prev];
      if (campo === "nota_final") {
        let limpio = valor.replace(",", ".");
        if (limpio === "" || limpio === "." || !isNaN(limpio)) {
          copia[index][campo] = limpio;
        }
      } else {
        copia[index][campo] = valor;
      }
      return copia;
    });
  };

  const handleBlurNota = (index) => {
    setNotas((prev) => {
      const copia = [...prev];
      const val = copia[index].nota_final;
      if (val !== "" && !isNaN(val)) {
        copia[index].nota_final = Number(val).toString();
      }
      return copia;
    });
  };

  /* =========================
      ACCIONES (GUARDAR/PUBLICAR)
  ========================= */
  const guardarNotas = async () => {
    try {
      const payload = notas.map((n) => ({
        estudiante_id: n.estudiante_id,
        nota_final: n.nota_final === "" ? 0 : parseFloat(n.nota_final).toFixed(2),
        comentario: n.comentario || "",
        materia_id: seleccion.materia,
        periodo_id: seleccion.periodo,
        grado: seleccion.grado,
        grupo: seleccion.grupo,
      }));

      await api.post("/guardar-notas", { notas: payload });
      alert("✅ Notas guardadas correctamente");
      setEditando(false);
      cargarNotas();
    } catch (err) {
      alert(err.response?.data?.msg || "Error guardando notas");
    }
  };

  const publicarNotas = async () => {
    if (!puedePublicar) return alert("❌ Fecha límite vencida");
    try {
      await api.post("/notas/publicar", {
        grado: seleccion.grado,
        grupo: seleccion.grupo,
        materia_id: seleccion.materia,
        periodo_id: seleccion.periodo,
      });
      alert("📢 Notas publicadas");
      cargarNotas();
    } catch (err) {
      alert(err.response?.data?.msg || "Error publicando");
    }
  };

  /* =========================
      VISTA (UI)
  ========================= */
  return (
    <div className="modulo-notas-container">
      <h2>📘 Calificaciones Finales</h2>

      <div className="filtros-grid">
        <select value={seleccion.grado} onChange={(e) => handleGradoChange(e.target.value)}>
          <option value="">Grado</option>
          {grados.map((g) => <option key={g} value={g}>{g}</option>)}
        </select>

        <select value={seleccion.grupo} onChange={(e) => handleGrupoChange(e.target.value)}>
          <option value="">Grupo</option>
          {grupos.map((g) => <option key={g} value={g}>{g}</option>)}
        </select>

        <select value={seleccion.materia} onChange={(e) => handleMateriaChange(e.target.value)}>
          <option value="">Materia</option>
          {materias.map((m) => <option key={m.id} value={m.id}>{m.nombre}</option>)}
        </select>

        <select value={seleccion.periodo} onChange={(e) => handlePeriodoChange(e.target.value)}>
          <option value="">Periodo</option>
          {periodos.map((p) => (
            <option key={p.id} value={p.id}>
              {p.nombre}{Number(p.activo) === 1 ? " (activo)" : ""}
            </option>
          ))}
        </select>
      </div>

      {mensajeFecha && <p className="mensaje-fecha-alerta">{mensajeFecha}</p>}

      {loading ? (
        <div className="loader">Cargando estudiantes...</div>
      ) : (
        <table className="tabla-notas-finales">
          <thead>
            <tr>
              <th>Estudiante</th>
              <th style={{ width: "120px" }}>Nota</th>
              <th>Desempeño</th>
              <th>Comentario</th>
            </tr>
          </thead>
          <tbody>
            {notas.length === 0 ? (
              <tr><td colSpan="4" className="text-center">Seleccione los filtros para cargar la planilla</td></tr>
            ) : (
              notas.map((n, i) => (
                <tr key={n.estudiante_id}>
                  <td className="nombre-estudiante">
                    {n.apellidos_estudiante} {n.nombres_estudiante}
                  </td>
                  <td>
                    <input
                      type="text"
                      className="input-nota-final"
                      disabled={!editando}
                      value={n.nota_final}
                      onChange={(e) => handleNotaUpdate(i, "nota_final", e.target.value)}
                      onBlur={() => handleBlurNota(i)}
                      placeholder="0.00"
                    />
                  </td>
                  <td className="col-desempeno">{n.desempeño || "-"}</td>
                  <td>
                    <input
                      className="input-comentario"
                      disabled={!editando}
                      value={n.comentario || ""}
                      onChange={(e) => handleNotaUpdate(i, "comentario", e.target.value)}
                      placeholder="Sin comentario"
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}

      <div className="acciones-footer">
        {!editando ? (
          <button className="btn-editar" onClick={() => setEditando(true)}>✏️ Editar Notas</button>
        ) : (
          <button className="btn-guardar" onClick={guardarNotas}>💾 Guardar Cambios</button>
        )}
        <button
          className="btn-publicar"
          onClick={publicarNotas}
          disabled={!puedePublicar || notas.length === 0}
        >
          📢 Publicar al Boletín
        </button>
      </div>
    </div>
  );
};

export default ModuloNotasFinales;